import { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';
import TagsService from '../API/TagsService';
import AuthorsService from '../API/AuthorsService';
import BooksService from '../API/BooksService';

export type GlobalDataType = {
  tags: any[];
  setTags: (data: any) => void;
  authors: any[];
  setAuthors: (data: any) => void;
  books: any[];
  setBooks: (data: any) => void;
  fetchAuthors: () => void;
  fetchTags: () => void;
  fetchBooks: () => void;
};

export const DataContext = createContext<GlobalDataType>({
  tags: [],
  setTags: () => {},
  authors: [],
  setAuthors: () => {},
  books: [],
  setBooks: () => {},
  fetchAuthors: () => {},
  fetchTags: () => {},
  fetchBooks: () => {},
});

export const DataProvider = ({ children }: PropsWithChildren<{}>) => {
  const [tags, setTags] = useState([]);
  const [authors, setAuthors] = useState([]);
  const [books, setBooks] = useState([]);

  const fetchTags = () => {
    TagsService.allNoPagination().then((res: any) => {
      setTags(res.data);
    });
  };

  const fetchAuthors = () => {
    AuthorsService.allNoPagination().then((res: any) => {
      setAuthors(res?.data);
    });
  };

  const fetchBooks = () => {
    BooksService.allNoPagination().then((res: any) => {
      setBooks(res?.data);
    });
  };

  useEffect(() => {
    fetchTags();
    fetchAuthors();
    fetchBooks();
  }, []);

  return (
    <DataContext.Provider
      value={{
        tags,
        setTags,
        authors,
        setAuthors,
        books,
        setBooks,
        fetchTags,
        fetchAuthors,
        fetchBooks,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export function useData() {
  return useContext(DataContext);
}
